import { Skeleton } from '@mui/material';
import React from 'react';

import SpaceSizes from '../../../../theme/foundations/spacing/SpaceSizes';

export const UserFormSkeleton = () => {
  return <Skeleton height={SpaceSizes.xl} width="100%" />;
};
